import {useState, useEffect} from 'react';

type Option = {
    label: string;
    [key: string]: any;
};

const sortByRank = (list: Option[], query: string) => {
    return list
        .map(item => {
            const label = item.label.toLowerCase();
            let score = 0;
            // Exact match
            if (label === query) score += 100;
            // Starts with the input
            if (label.startsWith(query)) score += 50;
            // Contains the input (with positional weight)
            const position = label.indexOf(query);
            score += 25 - position; // Earlier matches get a small boost

            return {item, score};
        })
        .sort((a, b) => b.score - a.score || a.item.label.length - b.item.label.length) // Tie-breaking: prefer shorter labels
        .map(entry => entry.item); // Return only the sorted items
};

export const useBatchedFilteredList = (list: Option[], batchSize: number, query: string) => {
    const [batchedItems, setBatchedItems] = useState([]);
    const [currentBatch, setCurrentBatch] = useState(0);

    useEffect(() => {
        setBatchedItems([]);
        setCurrentBatch(0);
    }, [query]);

    useEffect(() => {
        const start = currentBatch * batchSize;
        const end = start + batchSize;
        const filteredItems = list.filter(opt =>
            opt.label?.toLowerCase()?.includes(query?.toLowerCase())
        );
        const options =
            query?.length > 2 ? sortByRank(filteredItems, query.toLowerCase()) : filteredItems;
        const res = options.slice(start, end);

        !query && currentBatch === 0
            ? setBatchedItems(res)
            : setBatchedItems(prevItems => [...prevItems, ...res]);
    }, [list, query, currentBatch, batchSize]);

    const loadMore = () => {
        setCurrentBatch(prevBatch => prevBatch + 1);
    };

    return {batchedItems, loadMore};
};
